import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';
import { EmailfileuploadService } from '../email/email-fileupload/service/emailfileupload.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { LoginService } from '../../../components/login/service/login.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-text-fileupload',
  templateUrl: './text-fileupload.component.html',
  styleUrl: './text-fileupload.component.scss'
})
export class TextFileuploadComponent {
  fileData: any = [];
  fileDataName: any = [];
  showComponent = false;
  storeFormDataPayload: any = [];
  storeAudioApiService: any[] = [];
  storePdfApiService: any[] = [];
  storeTextApiService: any[] = [];
  selectFile = '';
  hideMic = false;
  topicsFileData: any = [];
  topicsValue: any = [];
  uploadForm!: FormGroup;
  showCard = false;
  topicsData: any = [];
  sampleArray: any = [];
  editTopic: any;
  countCall!: number;
  countMetric!: number;
  getIndex!: number;
  uuid = uuidv4();
  storeFormData: any;
  selectedCar!: number;
  disableInput = true;
  formObject = {};
  agentNameUD!: any;
  inputBoolean = true;
  spinner = false;
  disableUpBtn = false;
  languageAudio: any = [];
  fileIndex!: number;
  private readonly notifier: NotifierService;
  @Input() agentname: any;
  splitPattern = new RegExp('[,;]');
  isDirty = false;
  openModal = false;
  getFileEvent: any;
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    trigger: 'hover',
    shadow: true,
  };
  @ViewChild('fileUpload') fileUploadEle!: ElementRef;
  @ViewChild('fileUpload2') fileUploadEle2!: ElementRef;
  @ViewChild('fileUpload3') fileUploadEle3!: ElementRef;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective!: DaterangepickerDirective;
  getDateData: any;
  startDate: any;
  convertJson: any;
  fileUploadCountBoolean: boolean = true;
  userDetails:any;
  selectedApps:any;
  call_type_id:any;
   constructor(
      private uploadService: EmailfileuploadService,
      private fb: FormBuilder,
      private ngSelect: NgSelectConfig,
      private service:LoginService,
      private notifierService: NotifierService,
      private router: Router
    ) {
      this.ngSelect.notFoundText = 'Custom not found';
      this.notifier = notifierService;
    }

    canDeactivate(): boolean {
        return !this.isDirty;
      }
    
      ngOnChanges() {}
    
      ngOnInit(): void {
         let user:any = localStorage.getItem("user");
           
              var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
                 this.userDetails = JSON.parse(data);
        this.agentNameUD = this.userDetails;
       /* this.uploadForm = this.fb.group({
          displayName: [null, Validators.required],
          customerName: [null, Validators.required],
          agentName: [localStorage.getItem('loginuser'), Validators.required],
          bounds: [null],
          topicName: [null, Validators.required],
          keywords: [null],
          alertKeywords: [null],
          sensitiveKeywords: [null],
          hideKeywords: [null],
          deleteKeywords: [null],
          negativeKeywords: [null],
          positiveKeywords: [null],
          auditComments: [null],
          language: [null],
          emailfrom: [''],
          emailto: [''],
          cc: [''],
          bcc: [''],
          emailsubject: [''],
          emaildate: [''],
          isrepeat: [false]
        }); */
        this.uploadForm = this.fb.group({
          config_id: [null, Validators.required],
          });
        this.languageAudio = [
          { name: 'English', code: 'en-US' },
          { name: 'Spanish', code: 'es-ES' },
          { name: 'Tamil', code: 'ta-IN' },
          { name: 'Hindi', code: 'hi-IN' },
          { name: 'Marathi', code: 'mr-IN' },
          { name: 'Bengali', code: 'bn-IN' },
          { name: 'Gujarati', code: 'gu-IN' },
          { name: 'Malayalam', code: 'ml-IN' },
          { name: 'Kannada', code: 'kn-IN' },
          { name: 'Telugu', code: 'te-IN' },
        ];

               if(localStorage.getItem('selectedApps')){
      this.selectedApps=localStorage.getItem('selectedApps')?.toString() || "";
    }
   if(this.selectedApps=="email"){
      this.call_type_id = 1;
     
    }
    if(this.selectedApps=="text"){
      this.call_type_id = 2;
    
    }
    if(this.selectedApps=="document"){
      this.call_type_id = 3;
     
    }
      //  this.uploadForm.controls['language'].setValue(this.languageAudio[0].code);
      }
      // get callCategoryForm() {
      //   return this.uploadForm.controls['callCategoryForm'] as FormArray;
      // }
    
      // get metricForm() {
      //   return this.uploadForm.controls['metricForm'] as FormArray;
      // }
    
      // addcallCategoryForm() {
      //   const lessonForm = this.fb.group({
      //     callCategory: [null, Validators.required],
      //     callKeyword: [null, Validators.required],
      //     callColor: [null, Validators.required],
      //   });
      //   this.callCategoryForm.push(lessonForm);
      //   this.showCard = true;
      // }
    
      // deletecallCategoryForm(index: number) {
      //   this.callCategoryForm.removeAt(index);
      // }
    
      // addMetricForm() {
      //   const lessonForm = this.fb.group({
      //     metricCategory: [null, Validators.required],
      //     metricKeyword: [null, Validators.required],
      //     metricScore: [null, Validators.required],
      //   });
      //   this.metricForm.push(lessonForm);
      //   this.showCard = true;
      // }
    
      // deleteMetricForm(index: number) {
      //   this.metricForm.removeAt(index);
      // }
    
      onFileChange(event: any) {
        this.getFileEvent = event;
        let format = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/;
        if (this.getFileEvent.target.files.length > 0) {
          this.isDirty = true;
          for (let i = 0; this.getFileEvent.target.files.length > i; i++) {
            const file = this.getFileEvent.target.files[i];
            // if (format.test(file.name)) {
            //   this.notifier.notify(
            //     'default',
            //     "Sorry we can't process the File name with special character."
            //   );
            // } else {
              this.fileData.push(file);
              this.fileDataName.push(file.name);
            //}
          }
        }
        this.containsDuplicate(this.fileDataName);
    
        // if (this.selectFile === 'audio') {
        //   this.fileUploadEle.nativeElement.value = null;
        // }
        // if (this.selectFile === 'pdf') {
        //   this.fileUploadEle2.nativeElement.value = null;
        // }
        // if (this.selectFile === 'email') {
        //   this.fileUploadEle3.nativeElement.value = null;
        //   this.uploadForm.controls['emailfrom'].setValidators(Validators.required);
        // } else {
        //   this.uploadForm.controls['emailfrom'].clearValidators();
        //   this.uploadForm.controls['emailfrom'].updateValueAndValidity();
        // }
      }
      containsDuplicate(array: any) {
        if (array.length !== new Set(array).size) {
          this.notifier.notify('default', 'Duplicate files are not allowed');
          this.fileData = this.removeDuplicates2(this.fileData, 'name');
          this.fileDataName = this.removeDuplicates1(this.fileDataName);
        }
      }
      callTopics() {
        this.showComponent = true;
        if (this.showComponent) {
          this.isDirty = true;
          // this.uploadForm.controls['language'].setValue('en-US');
          // this.uploadForm.controls['agentName'].setValue(
          //   localStorage.getItem('agent')
          // );
          // this.uploadService.getFile().subscribe((res: any) => {
          //   this.topicsFileData = [];
          //   this.topicsFileData = res.topics;
          // });
    
           this.uploadService.getTopic().subscribe((res: any) => {
            this.topicsFileData = [];
            this.topicsFileData = res.filter((data:any)=>data['call_type_id']==this.call_type_id);
          });
        }
      }
    
      removeDuplicates1(data: any) {
        return data.filter(
          (value: any, index: any) => data.indexOf(value) === index
        );
      }
      removeDuplicates2(myArray: any, Prop: any) {
        return myArray.filter((obj: any, pos: any, arr: any) => {
          return arr.map((mapObj: any) => mapObj[Prop]).indexOf(obj[Prop]) === pos;
        });
      }
    
      get f() {
        return this.fileData.value;
      }
    
      filesFormat(value: any) {
        this.selectFile = value;
        // if (this.selectFile === 'pdf') {
        //   this.uploadForm.controls['customerName'].setValue('John');
        // }
        // if (this.selectFile === 'email') {
        //   this.uploadForm.controls['customerName'].setValue('John');
        // }
        // if (this.selectFile === 'audio') {
        //   this.uploadForm.controls['customerName'].setValue('');
        // }
      }
    
      deleteSelectFile(index: number) {
        this.fileData.splice(index, 1);
        if (this.fileData.length === 0) {
          this.fileData = [];
          this.getFileEvent = '';
        }
      }
      justShowIndex(index: number) {
        this.fileIndex = index;
      }
    
      chooseTopic() {
       /* const id = this.uploadForm.controls['topicName'].value;
        if (this.uploadForm.controls['topicName'].valid) {
          this.uploadService.getTopic().subscribe((sub) => {
            this.editTopic = sub;
            this.formObject = {
              topicName: id,
              keywords: this.editTopic.keywords
                ? this.editTopic.keywords?.split(',')
                : null,
              alertKeywords: this.editTopic.alert_words
                ? this.editTopic.alert_words?.split(',')
                : null,
              sensitiveKeywords: this.editTopic.sensitive_words
                ? this.editTopic.sensitive_words?.split(',')
                : null,
              hideKeywords: this.editTopic.hide_words
                ? this.editTopic.hide_words?.split(',')
                : null,
              deleteKeywords: this.editTopic.delete_words
                ? this.editTopic.delete_words?.split(',')
                : null,
            };
            this.uploadForm.patchValue(this.formObject);
            this.disableInput = false;
          });
        } else if (this.uploadForm.controls['topicName'].invalid) {
          Object.keys(this.formObject).forEach((key) => {
            this.uploadForm.controls[key].reset();
          });
          this.disableInput = true;
        } */
      }
    
      onSubmit() {
        this.inputBoolean = true;
        if (this.selectFile === 'text') {
          if(this.uploadForm.valid){
            for (let i = 0; this.fileData.length > i; i++) {
              const formDataAudio = new FormData();
              if (this.selectFile === 'text') {
                formDataAudio.append('file', this.fileData[i]);
                this.uploadService.uploadText(this.uploadForm.value['config_id'],formDataAudio).subscribe((res:any)=>{
                    console.log("upload res",res);
                    this.notifier.notify('default',res['results'][0]['message']);
                    this.fileData = [];
                    this.showComponent = false;
                },(error:HttpErrorResponse)=>{
                  this.notifier.notify('default',error['error']['message']);
                  this.fileData = [];
                });
              }
            }
          }
        }else if(this.selectFile==='email-xlsx'){
    
           if(this.uploadForm.valid){
            for (let i = 0; this.fileData.length > i; i++) {
              const formDataAudio = new FormData();
              if (this.selectFile === 'email-xlsx') {
                formDataAudio.append('file', this.fileData[i]);
                this.uploadService.uploadEmailExcel(this.uploadForm.value['config_id'],formDataAudio).subscribe((res:any)=>{
                    console.log("upload res",res);
                    this.notifier.notify('default',res[0]['message']);
                    this.fileData = [];
                    this.showComponent = false;
                },(error:HttpErrorResponse)=>{
                  this.notifier.notify('default',error['error']['message']);
                  this.fileData = [];
                });
              }
            }
           }
        }
    
   
      }
    
      reDirectMainPage() {
        this.showComponent = false;
        this.fileData = [];
        this.isDirty = false;
        this.uploadForm.reset();
        this.getFileEvent = null;
        this.disableInput = true;
        this.spinner = false;
        this.disableUpBtn = false;
        this.uploadForm.controls['customerName'].setValue('');
        this.uploadForm.controls['emaildate'].setValue('');
        this.fileUploadCountBoolean = true;
        this.storeAudioApiService = [];
        this.storePdfApiService = [];
        this.storeTextApiService = [];
        if (this.selectFile === 'audio') {
          this.fileUploadEle.nativeElement.value = null;
        }
        if (this.selectFile === 'pdf') {
          this.fileUploadEle2.nativeElement.value = null;
        }
        if (this.selectFile === 'text') {
          this.fileUploadEle3.nativeElement.value = null;
        }
      }
    
      getDateSearchData(value: any) {
        this.getDateData = value;
        this.startDate = new DatePipe('en-US').transform(
          this.getDateData?.startDate?.$d || '',
          'MM/dd/yyyy'
        );
      }

}
